const _onMoveChangeMoves = Game.prototype.onMoveChangeMoves;
Game.prototype.onMoveChangeMoves = function (...args) {
    if (!cleverapps.styles.BaseGoalView.actor.disableAttack) {
        return;
    }

    _onMoveChangeMoves.call(this, ...args);
};

Game.prototype.enemyAttackStage = function () {
    if (cleverapps.styles.BaseGoalView.actor.disableAttack) {
        return;
    }

    if (this.tutorial && !this.tutorial.finished) {
        return;
    }

    if (this.enemiesAttack) {
        this.enemiesAttack = false;

        Game.currentGame.counter.setTimeout(() => {
            if (!this.goals.attack()) {
                return;
            }

            Game.currentGame.counter.setTimeout(() => {
                this.decMoves();
                this.shakeField();
            }, Game.ENEMIES_ATTACK_TIME);
        }, Game.BEFORE_ENEMIES_ATTACK_TIME);
    }
};

const oldUpdateOneTimePerMoveFeatures = Game.prototype.updateOneTimePerMoveFeatures;
Game.prototype.updateOneTimePerMoveFeatures = function () {
    oldUpdateOneTimePerMoveFeatures.call(this);
    this.enemiesAttack = true;
};

Game.SelectEnemies = function (level) {
    const enemies = {};
    if (level.meta.enemies) {
        level.meta.enemies.forEach((type) => {
            enemies[type] = Game.GOAL_ENEMY_TYPES[type];
        });
    }

    const selectRandom = function (goal, type, index) {
        if (type === undefined) {
            type = [];
            for (let i = 0; i < cleverapps.styles.BaseGoalView.enemies.length; i++) {
                if (i === Game.GOAL_ENEMY_TYPES[CoinCell.GOAL_ID]) {
                    continue;
                }

                type.push(i);
            }
        }

        type = cleverapps.substract(type, Object.values(enemies));

        const pseudo = PseudoRandom.GET("secondary");
        pseudo.seed((level.getHumanReadableNumber() + index) * 127);

        return pseudo.choose(type);
    }; 

    Object.keys(enemies).forEach((goal, index) => {
        const type = enemies[goal];
        if (typeof type === "number") {
            return;
        }

        enemies[goal] = selectRandom(goal, type, index);
    });

    return enemies;
};

Game.BEFORE_ENEMIES_ATTACK_TIME = 200;
Game.ENEMIES_ATTACK_TIME = 600;
Game.MESSAGE_TIME = 800;

Game.GOAL_ENEMY_TYPES = {};